import { useState } from 'react';
import { Coupon } from '@cencosud-cencommerce/paris-uikit';

import ModalRemoveCoupon from '@/modules/perseo-billing/components/coupon-component/ModalRemoveCoupon';
import useCoupon from '@/modules/perseo-billing/components/coupon-component/useCouponComponent';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks/use-gtm-billing';

export const CouponComponent = () => {
  const couponProps = useCoupon();
  const [showRemoveCouponModal, setShowRemoveCouponModal] = useState(false);
  const { addCouponGtm, clickDeleteCouponGtm } = useGtmBillingProduct();

  const handleCloseModal = () => {
    setShowRemoveCouponModal(false);
  };

  const handleAddCoupon = (couponCode: string) => {
    addCouponGtm(couponCode);
    couponProps.onAdd(couponCode);
  };

  const handleRemoveCoupon = () => {
    clickDeleteCouponGtm(couponProps?.couponName);
    setShowRemoveCouponModal(true);
  };

  return (
    <>
      <Coupon
        {...couponProps}
        onRemove={() => {
          handleRemoveCoupon();
        }}
        onAdd={(couponCode: string) => {
          handleAddCoupon(couponCode);
        }}
      />

      <ModalRemoveCoupon
        couponName={couponProps?.couponName}
        onClose={handleCloseModal}
        isOpen={showRemoveCouponModal}
        removeCoupon={couponProps?.removeCoupon}
      />
    </>
  );
};

CouponComponent.displayName = 'CouponComponent';
export default CouponComponent;
